export const NAME = 'cp:opendialog'

export type Event = CustomEvent

export default function createEvent() {
    return new Event(NAME, {
        bubbles: true,
        composed: true,
    })
}
